// client/src/components/utils/FileUploadField.js
//
// Campo di upload file "moderno": dropzone con drag & drop, icona e
// anteprima del file selezionato (nome + dimensione + rimozione).
// La validazione resta a carico del componente chiamante: qui si
// notifica solo il File scelto tramite onSelect / la rimozione con onClear.

import React, { useRef, useState } from 'react';
import { UploadCloud, FileText, X } from 'lucide-react';
import { formatFileSize } from './attachmentUtils';

const FileUploadField = ({
  id,
  accept,
  file = null,
  onSelect,
  onClear,
  disabled = false,
  ctaText = 'Drag the file here or click to upload',
  hintText = '',
  changeText = 'Change file',
  removeText = 'Remove'
}) => {
  const inputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);

  const openPicker = () => {
    if (!disabled) inputRef.current?.click();
  };

  const handleInputChange = (e) => {
    const f = e.target.files?.[0] || null;
    if (f) onSelect?.(f);
    // consente di riselezionare lo stesso file dopo una rimozione
    e.target.value = '';
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    if (disabled) return;
    const f = e.dataTransfer.files?.[0] || null;
    if (f) onSelect?.(f);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      openPicker();
    }
  };

  return (
    <div className="upload-field">
      <input
        ref={inputRef}
        id={id}
        type="file"
        accept={accept}
        onChange={handleInputChange}
        disabled={disabled}
        className="upload-field-native"
        tabIndex={-1}
      />

      {file ? (
        <div className="upload-file">
          <span className="upload-file-icon">
            <FileText size={18} />
          </span>
          <span className="upload-file-meta">
            <span className="upload-file-name">{file.name}</span>
            <span className="upload-file-size">{formatFileSize(file.size)}</span>
          </span>
          <div className="upload-file-actions">
            <button type="button" className="btn btn-light btn-sm" onClick={openPicker} disabled={disabled}>
              {changeText}
            </button>
            <button
              type="button"
              className="btn btn-danger btn-sm upload-file-remove"
              onClick={() => onClear?.()}
              disabled={disabled}
              aria-label={removeText}
            >
              <X size={14} />
            </button>
          </div>
        </div>
      ) : (
        <div
          className={`upload-dropzone${dragOver ? ' is-dragover' : ''}${disabled ? ' is-disabled' : ''}`}
          role="button"
          tabIndex={disabled ? -1 : 0}
          onClick={openPicker}
          onKeyDown={handleKeyDown}
          onDragOver={(e) => {
            e.preventDefault();
            if (!disabled) setDragOver(true);
          }}
          onDragLeave={() => setDragOver(false)}
          onDrop={handleDrop}
        >
          <span className="upload-dropzone-icon">
            <UploadCloud size={22} />
          </span>
          <span className="upload-dropzone-text">{ctaText}</span>
          {hintText ? <span className="upload-dropzone-hint">{hintText}</span> : null}
        </div>
      )}
    </div>
  );
};

export default FileUploadField;
